import {
    apiRequest,
    AcManajerialCreate,
    AcManajerialEmployee,
    AcManajerialPeriod,
    AcManajerialKinerja,
    AcManajerialStankom,
    AcManajerialEmployeeDetail,
    AcManajerialLevelCompetence
} from "../../../../../services/adapters/Assesment/assesmentService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", AcManajerialCreate, {
            body: query
        }, true)
    }

    // fetchCategories = async (query) => {
    //     return await apiRequest("get", masterCategories, {
    //         params: query
    //     }, true)
    // }
    fetchEmployee = async (query) => {
        return await apiRequest("get", AcManajerialEmployee, {
            params: query
        }, true)
    }
    fetchPeriod = async (query) => {
        return await apiRequest("get", AcManajerialPeriod, {
            params: query
        }, true)
    }
    fetchPerformance = async (query) => {
        return await apiRequest("get", AcManajerialKinerja, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcManajerialStankom, {
            params: query
        }, true)
    }
    fetchDetailEmployee = async (query) => {
        return await apiRequest("get", AcManajerialEmployeeDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcManajerialStankom, {
            params: query
        }, true)
    }
    fetcLevelCompetence = async (query) => {
        return await apiRequest("get", AcManajerialLevelCompetence, {
            params: query
        }, true)
    }
}

export default CreateRepository